/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Layers_TitleInputs */

const cs_integrations_layers_title = /** @type {(inputs: Integrations_Layers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kancelář vs osobní`)
};

const en_integrations_layers_title = /** @type {(inputs: Integrations_Layers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office vs personal`)
};

/**
* | output |
* | --- |
* | "Office vs personal" |
*
* @param {Integrations_Layers_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_layers_title = /** @type {((inputs?: Integrations_Layers_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Layers_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_layers_title(inputs)
	return cs_integrations_layers_title(inputs)
});